/*global require, document, window, console */
const MAPJS = require('mindmup-mapjs'),
	jQuery = require('jquery'),
	themeProvider = require('./theme'),
	ThemeProcessor = require('mindmup-mapjs-layout').ThemeProcessor,
	testMap = require('./example-map'),
	content = require('mindmup-mapjs-model').content,
	init = function () {
		'use strict';
		const container = jQuery('#container'),
			idea = content(testMap),
			imageInsertController = new MAPJS.ImageInsertController('http://localhost:4999?u='),
			mapModel = new MAPJS.MapModel(MAPJS.DOMRender.layoutCalculator, []);

		jQuery.fn.attachmentEditorWidget = function (mapModel) {
			return this.each(function () {
				mapModel.addEventListener('attachmentOpened', function (nodeId, attachment) {
					mapModel.setAttachment(
						'attachmentEditorWidget',
						nodeId, {
							contentType: 'text/html',
							content: window.prompt('attachment', attachment && attachment.content)
						}
					);
				});
			});
		};
		window.onerror = window.alert;


		jQuery('#themecss').themeCssWidget(themeProvider, new ThemeProcessor(), mapModel);
		container.domMapWidget(console, mapModel, false, imageInsertController);
		jQuery('body').mapToolbarWidget(mapModel);
		jQuery('body').attachmentEditorWidget(mapModel);
		var stateJson = getParameterByName("state");
		
		if(!stateJson) {
			mapModel.setIdea(idea);
        }

        mapModel.setUserMap = function (userMap) {
            mapModel.setIdea(content(userMap));
        };

		jQuery('#linkEditWidget').linkEditWidget(mapModel);
		window.mapModel = mapModel;
		jQuery('.arrow').click(function () {
			jQuery(this).toggleClass('active');
		});
		imageInsertController.addEventListener('imageInsertError', function (reason) {
			console.log('image insert error', reason);
		});
		container.on('drop', function (e) {
			const dataTransfer = e.originalEvent.dataTransfer;
			e.stopPropagation();
			e.preventDefault();
			if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
				const fileInfo = dataTransfer.files[0];
				if (/\.mup$/.test(fileInfo.name)) {
					const oFReader = new window.FileReader();
					oFReader.onload = function (oFREvent) {
						mapModel.setIdea(content(JSON.parse(oFREvent.target.result)));
					};
					oFReader.readAsText(fileInfo, 'UTF-8');
				}
			}
		});
		
		
		//Custom scripts
		$('#export-image').click(function() {
			var target = $('div[data-mapjs-role="stage"]')[0];
			
			var elements = $(target).find('svg').map(function() {
				var svg = $(this);
				var canvas = $('<canvas></canvas>').css({position: 'absolute', left:svg.css('left'), top: svg.css('top')});
			
				svg.replaceWith(canvas);

				// Get the raw SVG string and curate it
				var content = svg.wrap('<p></p>').parent().html();
				svg.unwrap();

				canvg(canvas[0], content);

				return {
					svg: svg,
					canvas: canvas
				};
			});
			
			var oldStyle = $(target).attr('style');
			var oldTransform = target.style.transform;
			target.style.transform = "";
			for(var i = 0; i< target.children.length; i++) {
				target.children[i].style.transform = oldTransform;
			}
			
			target.style.width = "auto";
			target.style.height = "100%";
			target.style.paddingTop = "68px";
			
			html2canvas(target).then(canvas => {
				elements.each(function() {
					this.canvas.replaceWith(this.svg);
				});
				
				target.style.transform = "";
				for(var i = 0; i< target.children.length; i++) {
					target.children[i].style.transform = "";
				}
			
				$(target).attr('style', oldStyle);
		
				var data = canvas.toDataURL();
				downloadURI(data.replace("image/png", "image/octet-stream"), "export-map.png");
			});
			
			//html2canvas(target).then(canvas => {
				//document.body.appendChild(canvas);
			//});
		});
		
		$("#export-gdrive").click(function() {
			var idea = mapModel.getIdea();
			downloadObjectAsJson(idea, "export-map");
		});
		
		$("#import-gdrive").click(function() {
			$('#import-gdrive-file').trigger("click");
		});
		
		$("#import-gdrive-file").change(function() {
			if (this.files.length > 0) {
				const fileInfo = this.files[0];
				if (/\.mup$/.test(fileInfo.name)) {
					const oFReader = new window.FileReader();
					oFReader.onload = function (oFREvent) {
						mapModel.setIdea(content(JSON.parse(oFREvent.target.result)));
					};
					oFReader.readAsText(fileInfo, 'UTF-8');
				}
			}
		});
	};
document.addEventListener('DOMContentLoaded', init);



//////////////////
// WEBPACK FOOTER
// ./src/start.js
// module id = 74
// module chunks = 0